var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pt-12", attrs: { fluid: "" } },
    [
      _vm.task
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "2" } },
                [
                  !_vm.isFinished && !_vm.progress
                    ? _c("v-progress-circular", {
                        attrs: {
                          size: "64",
                          color: "primary",
                          indeterminate: "",
                        },
                      })
                    : !_vm.isFinished
                    ? _c("v-progress-circular", {
                        attrs: {
                          size: "64",
                          color: "primary",
                          value: _vm.progress,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-col",
                [
                  _c(
                    "h2",
                    { staticClass: "page-title page-title__primary mb-2" },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _vm.statusText && !_vm.isFinished
                    ? _c("p", [_vm._v(_vm._s(_vm.statusText))])
                    : _vm._e(),
                  _vm.hasSteps
                    ? _c("p", [
                        _vm._v(
                          "Шаг " +
                            _vm._s(
                              (_vm.innerTask && _vm.innerTask.step_number) || 0
                            )
                        ),
                      ])
                    : _vm._e(),
                  _vm.innerTask &&
                  _vm.innerTask.inflation_factor_history &&
                  _vm.innerTask.inflation_factor_history.length &&
                  !_vm.isFinished
                    ? _c("p", [
                        _c("span", [
                          _vm._v(
                            "Осталось примерно: " +
                              _vm._s(_vm.timeLeft || "Неизвестно")
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.hasError
                    ? _c("v-alert", { attrs: { type: "error" } }, [
                        _vm._v(
                          _vm._s(
                            (_vm.innerTask && _vm.innerTask.error) ||
                              "Неизвестная ошибка"
                          )
                        ),
                      ])
                    : _vm._e(),
                  _c(
                    "v-expansion-panels",
                    { attrs: { accordion: "", multiple: "" } },
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [
                            _vm._v(
                              " Инфляционный фактор: " +
                                _vm._s(
                                  (_vm.innerTask &&
                                    _vm.innerTask.inflation_factor) ||
                                    "Неизвестно"
                                ) +
                                " "
                            ),
                          ]),
                          _c("v-expansion-panel-content", [
                            _vm.innerTask &&
                            _vm.innerTask.inflation_factor_history &&
                            _vm.innerTask.inflation_factor_history.length
                              ? _c(
                                  "p",
                                  [
                                    _c("plotly", {
                                      attrs: {
                                        data: _vm.historyPlotData,
                                        layout: _vm.plotLayout,
                                        "static-plot": true,
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("Ожидание данных..."),
                                ]),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", [
                            _vm._v("Полный лог"),
                          ]),
                          _c("v-expansion-panel-content", [
                            _vm.shownLog
                              ? _c("pre", { ref: "log", staticClass: "log" }, [
                                  _vm._v(_vm._s(_vm.shownLog)),
                                ])
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("Ожидание данных..."),
                                ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.isFinished && _vm.isPredict
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mt-4",
                          attrs: { color: "primary" },
                          on: { click: _vm.gotoResult },
                        },
                        [_vm._v("Посмотреть результаты")]
                      )
                    : _vm.isFinished
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mt-4",
                          attrs: { color: "primary" },
                          on: { click: _vm.gotoNewPredict },
                        },
                        [_vm._v("Запустить расчет")]
                      )
                    : _c(
                        "v-btn",
                        {
                          staticClass: "mt-4",
                          attrs: { color: "primary" },
                          on: { click: _vm.gotoList },
                        },
                        [_vm._v("К списку задач")]
                      ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "v-row",
            [
              _c("v-col", [
                _vm._v(
                  ' Расчетная задача пока не создана. Перейдите в раздел "Настройки" '
                ),
              ]),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }